
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/datenschutz",
      function () {
        return require("private-next-pages/info/datenschutz.tsx");
      }
    ]);
  